(function () {
  "use strict";

  EditGroupsSidebarCtrl.$inject = ['$scope', 'usersResource', '$timeout', 'groupsResource'];
  angular
    .module('trainerWebApp.controllers')
    .controller('EditGroupsSidebarCtrl', EditGroupsSidebarCtrl);

  function EditGroupsSidebarCtrl($scope, usersResource, $timeout, groupsResource) {
    var removeAction = 1;
    var addToAllAction = 2;
    var extendToAllAction = 3;
    var changes = {};
    var recentlyAddedGroupTimerPromise = null;

    $scope.multiEditMode = false;
    $scope.recentlyAddedGroup = null;

    $scope.selectOptions = {
      width: '100%',
      placeholder: "Add groups...",
      multiple: true,
      query: query,
      data: $scope.allUserGroups,
      minimumInputLength: 0,
      maximumInputLength: 40,
      allowClear: true,
      dropdownCssClass: "select2-dropdown-size-hack"
    };

    $scope.createGroupText = "Create new group: ";

    var availableGroupSelectItems = [];

    function refreshAvailableGroupSelectItems() {
      $scope.userGroups = $scope.userGroupsInEdit;
      var groupIdsNotAvailableForSelection = {};
      _.each($scope.userGroups, function (g) {
        if (g.count === 'All') {
          groupIdsNotAvailableForSelection[g.id] = true;
        }
      });

      availableGroupSelectItems = _.chain($scope.allUserGroups)
        .reject(function (g) {
          return groupIdsNotAvailableForSelection[g.id]
        })
        .map(function (g) {
          return {
            id: g.id,
            text: g.name
          }
        })
        .value();
    }

    $scope.$on('refreshAvailableGroupSelectItems', function () {
      refreshAvailableGroupSelectItems();
    });

    refreshAvailableGroupSelectItems();

    function query(query) {
      var data = {results: getAllResults(query.term, query.element)};
      query.callback(data);
    }

    function getAllResults(term, elem) {
      if (!term || term.length == 0)
        return availableGroupSelectItems;

      var termLower = term.toLowerCase();

      var result = _.filter(availableGroupSelectItems, function (item) {
        return item.text.toLowerCase().indexOf(termLower) >= 0;
      });

      if (!mfConfig.useGroupRestrictions) {
        var exists = _.find($scope.allUserGroups, function (item) {
          return item.name.toLowerCase() == (term || "").toLowerCase();
        });

        if ($.trim(term || "") && !exists) {
          var newItem = {id: -1, text: $scope.createGroupText  + term , value: $.trim(term)};
          if (elem.select2("container").hasClass('select2-drop-above')) {
            result.splice(0, 0, newItem);
          } else {
            result.push(newItem);
          }
        }
      }

      return result;
    }

    function exit() {
      clean();
      $scope.openDetailsSidebar();
    }

    $scope.cancelChanges = function () {
      exit();
    };

    $scope.canApplyChanges = function () {
      return $scope.manageUsersEditors.userGroupsEditor && !$scope.serverCallInProgress;
    };

    $scope.addGroup = function (group) {
      $scope.applyToAll(group.id);

      $scope.recentlyAddedGroup = group;
      if (recentlyAddedGroupTimerPromise) {
        $timeout.cancel(recentlyAddedGroupTimerPromise);
        recentlyAddedGroupTimerPromise = null;
      }
      recentlyAddedGroupTimerPromise = $timeout(function () {
        $scope.recentlyAddedGroup = null;
        recentlyAddedGroupTimerPromise = null;
      }, 5000);
    };

    $scope.applyToAll = function (groupId) {
      var group = _.find($scope.userGroups, function (g) {
        return g.id == groupId;
      });
      var wasInTheList = true;
      if (!group) {
        wasInTheList = false;
        group = {id: groupId, name: $scope.userGroupLookup[groupId].name};
        $scope.userGroups.push(group);
      }

      var currentAction = changes[groupId];
      if (currentAction == removeAction || wasInTheList) {
        changes[groupId] = extendToAllAction;
      } else if (!currentAction) {
        changes[groupId] = addToAllAction;
      }

      group.count = 'All';

      availableGroupSelectItems = _.reject(availableGroupSelectItems, function (item) {
        return item.id == groupId;
      });

      markDirty();
    };

    $scope.addNewGroup = function (groupName, cb) {
      var newGroup = {name: groupName};
      groupsResource.addGroups([newGroup], function (res) {
        $scope.addNewGroupToSearch({id: res.groups[0].id, name: res.groups[0].name});
        $scope.applyToAll(res.groups[0].id);
        cb();
      }, function (err) {
        cb();
      });
    };

    $scope.remove = function (groupId) {
      var currentAction = changes[groupId];
      if (currentAction == addToAllAction) {
        delete changes[groupId];
      } else if (currentAction == extendToAllAction || !currentAction) {
        changes[groupId] = removeAction;
      }

      var group = _.find($scope.userGroups, function (g) {
        return g.id == groupId;
      });
      if (group.count == 'All') {
        availableGroupSelectItems.push({
          id: group.id,
          text: group.name
        });
      }
      $scope.userGroups = _.reject($scope.userGroups, function (g) {
        return g.id == groupId;
      });
      markDirty();
      if ($scope.forceCloseDropDown)
        $scope.forceCloseDropDown();
    };

    function markDirty() {
      $scope.manageUsersEditors.userGroupsEditor = true;
    }

    function clean() {
      $scope.manageUsersEditors.userGroupsEditor = false;
      $scope.serverCallInProgress = false;
      $scope.hideSpinner();
    }

    $scope.applyChanges = function () {
      var changesList = _.pairs(changes);
      var userIds = _.pluck($scope.storedSelectedUsers, 'id');

      var saveData = {userIds: userIds, addGroupIds: [], removeGroupIds: []};

      _.each(changesList, function (pair) {
        var groupId = parseInt(pair[0]);
        var action = pair[1];
        if (action == addToAllAction || action == extendToAllAction) {
          saveData.addGroupIds.push(groupId);
        }
        else {
          saveData.removeGroupIds.push(groupId);
        }
      });

      $scope.serverCallInProgress = true;
      $scope.showSpinner();
      usersResource.updateUserGroups(saveData, function (res) {
        $scope.manageUsersEditors.userGroupsEditor = false;
        $scope.refreshSelectedUserInfo(function () {
          $scope.serverCallInProgress = false;
          clean();
          exit();
        });
      });
    };

    $scope.$watch('selectedUsers', function () {
      if ($scope.selectedUsers) {
        $scope.storedSelectedUsers = $scope.selectedUsers.slice();
        $scope.headerText = $scope.storedSelectedUsers.length + " users selected";
        $timeout(function () {
          $scope.multiEditMode = true;
        });
      }
    });
    $scope.$watch('selectedUser', function () {
      if ($scope.selectedUser) {
        $scope.storedSelectedUsers = [$scope.selectedUser];
        $scope.headerText = '1 user selected';
        $timeout(function () {
          $scope.multiEditMode = false;
        });
      }
    });
  }

})();
